import { render } from "./ServicePostePage.vue?vue&type=template&id=b8cb8314"
import script from "./ServicePostePage.vue?vue&type=script&lang=js"
export * from "./ServicePostePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__